
import { Injectable } from '@angular/core';
import { loadSpace } from '@usersnap/browser';
import { BehaviorSubject } from 'rxjs';
type SpaceApi = Awaited<ReturnType<typeof loadSpace>>;
       
type ValueKey = 'assignee' | 'custom' | 'labels' | 'visitor';
type OpenEvent = { apiKey: string; api: { setValue: (k: ValueKey, v: any) => void } };
type CloseEvent = { apiKey: string; isCancel: boolean };
type BeforeSubmitEvent = {
  apiKey: string;
  api: { setValue: (k: ValueKey, v: any) => void };
  values: { assignee?: string; custom?: any; labels?: string[]; visitor: string };
};
type SubmitEvent = { apiKey: string };

@Injectable({ providedIn: 'root' })
export class UsersnapService {
  public authSubject = new BehaviorSubject<any | null>(null);
  public authChanges$ = this.authSubject.asObservable();
  public bugWidgetSubject = new BehaviorSubject<null | any>(null);
  public bugWidgetChanges$ = this.bugWidgetSubject.asObservable();
  private api?: SpaceApi;
  private initPromise?: Promise<SpaceApi>;

  async init(spaceKey: string, user?: { userId?: string; email?: string; name?: string }, custom?: Record<string, any>) {
    if (!this.api) {
      this.api = await loadSpace(spaceKey);
    }
    await this.api.init({ user, custom });
    return this.api;
  }
  

  showProject(projectApiKey: string) { this.api?.show(projectApiKey); }
  logEvent(eventName: string) { this.api?.logEvent(eventName); }

  on(event: 'open', cb: (e: OpenEvent) => void): void;
  on(event: 'close', cb: (e: CloseEvent) => void): void;
  on(event: 'beforeSubmit', cb: (e: BeforeSubmitEvent) => void): void;
  on(event: 'submit', cb: (e: SubmitEvent) => void): void;
  on(event: any, cb: any) { this.api?.on(event, cb); }

  login(user: any) {
    this.authSubject.next(user);
  }

  logout() {
    this.authSubject.next(null);
  }

}
